// Espelha Forms::ScoringService#max_points (Ruby): campo de escolha
// contribui como antes (maior peso em escolha única select/radio, soma dos
// pesos POSITIVOS em checkbox); campo sem opção (texto, textarea, email,
// telefone, número, data) contribui com o único `answer_points`, ignorado se
// ausente/não numérico/<=0; `consent` nunca conta. Puramente informativo —
// nunca alimenta uma decisão, só o texto "Máximo: N" no editor — mas precisa
// bater com o Ruby, senão o painel mostra um número que o backend nunca
// produz.
//
// Math.trunc espelha o `to_i` do Ruby: sem ele, um <input type="number"
// min="0"> sem `step` deixa o usuário digitar "2,5" e o painel mostraria
// "Máximo: 72,5" enquanto o backend (que sempre trunca) calcula 72.
const CHOICE_TYPES = ['select', 'radio', 'checkbox'];

const choiceFieldMax = field => {
  const values = Object.values(field.option_points || {})
    .map(Number)
    .filter(Number.isFinite)
    .map(Math.trunc);
  if (!values.length) return 0;
  if (field.type === 'checkbox') {
    return values.filter(v => v > 0).reduce((a, b) => a + b, 0);
  }
  return Math.max(...values, 0);
};

// Espelha o String#to_i do Ruby, que o backend agora usa (safe_int em
// Forms::ScoringService) pra nunca levantar em cima de escalar solto: extrai
// só o inteiro do PREFIXO do valor e ignora o resto. `Number("12abc")` e
// `Number("1e3")` divergiam do Ruby ("12abc".to_i => 12, "1e3".to_i => 1,
// não 1000) — malformado no editor batia diferente na tela e no banco.
const toRubyInt = value => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? Math.trunc(value) : 0;
  }
  const match = String(value ?? '')
    .trim()
    .match(/^[+-]?\d+/);
  return match ? parseInt(match[0], 10) : 0;
};

const answerFieldMax = field => {
  const weight = toRubyInt(field.answer_points);
  return weight > 0 ? weight : 0;
};

export const maxPoints = fields =>
  (fields || [])
    .filter(field => field.type !== 'consent')
    .reduce((total, field) => {
      const contribution = CHOICE_TYPES.includes(field.type)
        ? choiceFieldMax(field)
        : answerFieldMax(field);
      return total + contribution;
    }, 0);
